import { fieldSalesRepInfoOCDR, fieldSubmittingOnBehalfOf } from '../../utils/constant';
import { getFieldValue } from '../utils';

const PrequalificationSection = (
  formFields,
  fieldName,
  isCreateOrderButtonVisible
) => {

  const isSubmittingOnBehalfOf = getFieldValue(
    fieldSubmittingOnBehalfOf,
    formFields
  );

  if (fieldName === fieldSalesRepInfoOCDR) {
    return true;
  }

  if (fieldName === fieldSubmittingOnBehalfOf && !isSubmittingOnBehalfOf) {
    isCreateOrderButtonVisible(true);
  }

 if (
    fieldName === fieldSubmittingOnBehalfOf &&
    isSubmittingOnBehalfOf
  ) {
    isCreateOrderButtonVisible(false);
  }

};

export default PrequalificationSection;
